import { cardActionsClasses, cardClasses, cardContentClasses, cardHeaderClasses, typographyClasses, type Theme } from "@mui/material"
import { SimpleWidgetCardTheme } from "core/themes/src/definitions/components.types"

export const createSimpleWidgetCardTheme = (_: Theme): SimpleWidgetCardTheme => ({
    styleOverrides: {},
    variants: [
        {
            props: { widgetVariant: "startpage" },
            style: {
                padding: ".25em",
                [`.${cardClasses.root}`]: {
                    borderRadius: "0px",
                    border: "0px",
                    [`.${cardHeaderClasses.root}`]: {
                        borderBottom: "1px solid #c8c8c8",
                        padding: ".5em",
                        color: "#000",
                        [`.${cardHeaderClasses.content}`]: {
                            background: "#c8c8c8",
                            padding: ".5em",
                            maxWidth: "255px",
                            clipPath: "polygon(0 0, 100% 0, 100% calc(100% - 15px), calc(100% - 15px) 100%, 0 100%)",
                            [`.${typographyClasses.root}`]: {
                                fontWeight: "600",
                            },
                        },
                    },
                    [`.${cardContentClasses.root}`]: {
                        padding: ".5em",
                    },
                    [`.${cardActionsClasses.root}`]: {
                        padding: "0 .5em .5em",
                    },
                },
            },
        },
    ],
})
